import * as yup from 'yup';

const clientKeySchema = yup
  .string('schemas.clientKey.string')
  .required('schemas.clientKey.string')
  .test('len', 'schemas.clientKey.exact', val => !val || (val && val.toString().length === 36));

export default clientKeySchema;
